/**
 * Contact Information Constants
 *
 * Centralized contact information for the application.
 * Update these values to reflect your organization's contact details.
 */

export const CONTACT_INFO = {
  /**
   * Support email for order-related inquiries
   */
  ordersEmail: 'orders@karbondigital.com',

  /**
   * General support email
   */
  supportEmail: 'support@karbondigital.com',

  /**
   * Sales contact email
   */
  salesEmail: 'sales@karbondigital.com',
} as const;

/**
 * External URLs
 *
 * Centralized external links for the application.
 * Update these values to reflect your organization's URLs.
 */
export const EXTERNAL_URLS = {
  /**
   * Contact sales page URL
   */
  contactSales: 'https://www.docufyai.com/contact/contact-sales',

  /**
   * Jira Service Management customer portal (Docufy Help Desk)
   */
  helpCenter: 'https://karbondigital.atlassian.net/servicedesk/customer/portal/1',
} as const;
